import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'rc-checkbox';
import DateTime from 'react-datetime';

import StatePicker from '../../../utility/state-picker';

class ProviderSurgeIncentiveSearchForm extends Component {
  clearStartingAfterDate = () => {
    this.props.changeField({ target: { name: 'starting-after', value: '' } });
  };

  changeActiveOnly = ({ target: { name, checked, type } }) => {
    this.props.changeField({ target: { name, checked, type } });

    if (checked) {
      this.clearStartingAfterDate();
    }
  };

  render() {
    const { formValues, submit, changeField } = this.props;

    return (
      <div className="search-filter">
        <h2>Filters</h2>
        <div className="filter">
          <label className="filter-label" htmlFor="id-picker">
            Location:
          </label>
          <StatePicker
            onSelect={(_, value) => changeField({ target: { name: 'state', value } })}
            id="state"
            name="state"
          />
        </div>
        <div className="filter">
          <Checkbox
            checked={Boolean(formValues['active-only'])}
            onChange={this.changeActiveOnly}
            id="active-only"
            name="active-only"
          />
          <label htmlFor="active-only">&nbsp; Active Only</label>
        </div>
        <div className="filter">
          <label htmlFor="starting-after">Starting after:</label>
          <DateTime
            value={formValues['starting-after']}
            onChange={value => changeField({ target: { name: 'starting-after', value } })}
            locale="en-US"
            closeOnSelect
            inputProps={{
              name: 'starting-after',
              id: 'starting-after',
              disabled: Boolean(formValues['active-only'])
            }}
          />
          <p>
            <span className="starting-after-clear" onClick={this.clearStartingAfterDate}>
              Clear
            </span>
          </p>
        </div>
        <hr className="full-width" />
        <button className="button surge-button" onClick={submit}>
          Search
        </button>
      </div>
    );
  }
}

ProviderSurgeIncentiveSearchForm.propTypes = {
  formValues: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  changeField: PropTypes.func.isRequired
};

export default ProviderSurgeIncentiveSearchForm;
